import React from 'react';
import { ShieldCheck, FileText, ExternalLink } from 'lucide-react';
import { useConsoleTheme } from '../../lib/theme';

function scoreTone(score) {
  if (score == null) return { color: '#6b7280', label: 'Not scored yet' };
  if (score >= 90) return { color: '#B0FC38', label: 'Excellent' };
  if (score >= 75) return { color: '#facc15', label: 'Needs attention' };
  return { color: '#ef4444', label: 'Improvement needed' };
}

// Light theme (docs/light-mode.md §3): the same tones as readable text on
// paper — accent text, the status hues at 800/700 (the generator's choice for
// status text), ink-3 for "not scored", ink for the score.
const LIGHT_TONE = {
  '#6b7280': '#5C584C',
  '#B0FC38': '#41680D',
  '#facc15': '#854D0E',
  '#ef4444': '#B91C1C',
};
const LIGHT_SCORE = '#1C1B16';

export default function AuditScoreCard({ score, pdfUrl }) {
  const { isLight } = useConsoleTheme();
  const darkTone = scoreTone(score);
  const tone = isLight ? { ...darkTone, color: LIGHT_TONE[darkTone.color] } : darkTone;
  return (
    <div className="p-5 rounded-2xl bg-white/[0.02] border border-white/[0.06] h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div className="text-[11px] font-medium text-gray-500 tracking-wider uppercase">
          WCAG compliance
        </div>
        <ShieldCheck className="w-4 h-4 text-gray-600" />
      </div>

      <div className="flex items-baseline gap-1.5">
        <div
          className="text-[1.75rem] leading-none font-semibold tracking-tight tabular-nums"
          style={{ color: score == null ? tone.color : (isLight ? LIGHT_SCORE : '#fff') }}
        >
          {score == null ? '—' : score}
        </div>
        <div className="text-sm text-gray-500 font-medium">/100</div>
      </div>

      <div className="mt-3 inline-flex items-center gap-1.5 text-[12px] font-medium" style={{ color: tone.color }}>
        <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: tone.color }} />
        {tone.label}
      </div>

      <div className="mt-auto pt-4">
        {pdfUrl ? (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[12px] text-gray-300 hover:text-white transition-colors"
          >
            <FileText className="w-3 h-3" />
            View full report
            <ExternalLink className="w-3 h-3" />
          </a>
        ) : (
          <span className="text-[11px] text-gray-600">Report will appear here after next audit.</span>
        )}
      </div>
    </div>
  );
}
